import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const eventInfoContainer = style({
  display: "grid",
  gridTemplateRows: "auto auto",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
  gap: vars.space.xs,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      gap: vars.space.m,
    },
  },
});
